<template>
  <div>
    <point-toolbar/>
    <v-container fluid>
      <v-row>
        <v-col
            xs="12"
            sm="12"
            md="6"
        >
          <v-card class="main-card">
            <v-card-text>
              <v-form ref="pointEditForm" lazy-validation>
                <v-layout wrap>
                  <v-flex
                      xs12
                  >
                    <v-text-field
                        v-model="editedItem.name"
                        label="Наименование"
                        :rules="pointEditRules"
                        required
                        @input="changeForm"
                    />
                  </v-flex>
                  <v-flex
                      xs12
                  >
                    <v-text-field
                        v-model="editedItem.point_number"
                        label="Идентификатор Точки учёта"
                        :rules="pointEditRules"
                        required
                        @input="changeForm"
                    />
                  </v-flex>
                  <v-flex
                      xs12
                  >
                    <v-autocomplete
                        v-model="editedItem.customer_id"
                        :items="customers"
                        label="Абонент"
                        item-text="name"
                        item-value="customer_id"
                        no-data-text="Нет доступных абонентов"
                        :menu-props="{maxHeight:'auto'}"
                        @input="changeForm"
                    />
                  </v-flex>
                  <v-flex
                      xs12
                  >
                    <v-text-field
                        v-model="editedItem.address"
                        label="Адрес"
                        :rules="pointEditRules"
                        required
                        @input="changeForm"
                    />
                  </v-flex>
                  <v-flex
                      xs12
                  >
                    <v-text-field
                        v-model="editedItem.remark"
                        label="Примечание"
                        @input="changeForm"
                    />
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
            xs="12"
            sm="12"
            md="6"
        >
          <v-card class="main-card">
            <v-card-title>Лимит потребления по точке учета</v-card-title>
            <v-card-text>

              <div class="d-flex flex-column">
                <div>
                  <svg width=15 height=15>
                    <line stroke-width="30" x1="0" y1="0" x2="15" y2="0" stroke="#e5e5e5"></line>
                  </svg>
                  <span>Установленный лимит: <v-menu
                      v-model="showConsumptionEditMenu"
                      :close-on-content-click="false"
                      absolute
                      offset-y
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <a href="#"
                       v-bind="attrs"
                       v-on="on">{{ editedItem.energy_limit }}</a>
                  </template>
                  <v-card class="pa-4 pb-0"
                  >
                    <v-text-field
                        v-model="editedItem.energy_limit"
                        label="Наименование"
                        type="number"
                        @input="changeForm"
                    />
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                          text
                          @click="showConsumptionEditMenu = false"
                      >
                        Ок
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu> кВт*ч</span>

                </div>

              </div>
              <div class="d-flex flex-column">
                <div>
                  <svg width=15 height=15>
                    <line stroke-width="30" x1="0" y1="0" x2="15" y2="0" stroke="#cddb39"></line>
                  </svg>
                  <span>Потребление в текущем месяце: {{ pointConsumption }} кВт*ч</span>
                </div>
              </div>
              <div class="text-center pt-4">
                <v-progress-circular
                    :rotate="90"
                    :size="230"
                    :width="15"
                    :value="pointConsumption/editedItem.energy_limit*100"
                    color="lime"
                >
                  <div class="text-center">
                    <div class="text-h4 black--text">{{ pointConsumption }}</div>
                    <div class="text-h6 black--text">кВт*ч</div>
                  </div>
                </v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer/>
        <div
            v-if="changed"
            class="px-3 save_block"
        >
          <v-btn
              color="orange darken-1"
              text
              @click.native="save"
          >
            Сохранить
          </v-btn>
          <v-btn
              color="red darken-1"
              text
              @click.native="cancel"
          >
            Отмена
          </v-btn>
        </div>
      </v-card-actions>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import PointToolbar from '../points/PointToolbar'

const API_URL = 'points'
export default {
  name: 'Points',
  components: {
    PointToolbar
  },
  data () {
    return {
      pointEditRules: [
        v => !!v || 'Заполните это поле!'
      ],
      point_id: this.$route.params['id'],
      update: true,
      changed: true,
      visible: false,
      editedItem: {
        point_id: '',
        point_number: '',
        customer: '',
        address: '',
        geopoint: '',
        name: '',
        remark: '',
        counter: '',
        energy_limit: null
      },
      defaultItem: {
        point_id: '',
        point_number: '',
        address: '',
        geopoint: '',
        name: '',
        remark: '',
        counter: '',
        energy_limit: 5000
      },
      customers: [],
      pointConsumption: 0,
      showConsumptionEditMenu: false
    }
  },
  watch: {
    editedItem () {
      this.changeForm()
    }
  },
  mounted () {
    this.getItemApi()
    this.getCustomers()
  },
  methods: {
    getCustomers () {
      axios.get(`/api/customers/?page_size=all`)
        .then((response) => {
          this.customers = response.data.results
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getItemApi () {
      axios.get(`/api/${API_URL}/${this.point_id}/`)
        .then((response) => {
          this.editedItem = Object.assign({}, response.data)
          setTimeout(() => this.changed = false, 10)
          this.getPointConsumption()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getPointConsumption () {
      axios.get(`/api/${API_URL}/${this.point_id}/consumption/`)
          .then((response) => {
            /** @property {string} response.data.consumption__sum */
            this.pointConsumption = response.data.consumption__sum || 0
            setTimeout(() => this.changed = false, 10)
          })
          .catch((err) => {
            console.log(err)
          })
    },
    updateItemApi () {
      axios.put(`/api/${API_URL}/${this.point_id}/`, this.editedItem)
        .then((response) => {
          Object.assign(this.editedItem, response.data)
          setTimeout(() => this.changed = false, 10)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    addItemApi () {
      axios.post(`/api/${API_URL}/`, this.editedItem)
        .then((response) => {
          this.loading = false
          this.editedItem = Object.assign({}, response.data)
          setTimeout(() => this.changed = false, 10)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    changeForm () {
      if (!this.changed) {
        this.changed = true
      }
    },
    validate () {
      if (this.$refs.pointEditForm.validate()) {
        return true
      }
    },
    save () {
      if (this.validate()) {
        this.showConsumptionEditMenu = false
        if (this.update) {
          this.updateItemApi()
        } else {
          this.addItemApi()
        }
      }
    },
    cancel () {
      this.showConsumptionEditMenu = false
      this.getItemApi()
    }
  }
}
</script>

<style lang="scss">
  .save_block {
    padding-top: 13px;
    padding-bottom: 16px;
  }
  .main-card {
    height: 380px;
  }
</style>



// WEBPACK FOOTER //
// src/spa/points/PointEdit.vue